var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCookies = function SvgCookies(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.15 210.18c.9-2.6 1.87-5.14 3.07-7.47 5.31-10.28 16.92-18.15 15.26-30.98-.86-6.67-5-12.38-8.06-18.37-7.21-14.15 4.75-22.36 1.23-35.69-3.07-11.61-13.06-18.04-22.89-23.62-10.5-5.95-10.49-19.24-16.89-28.34-7.35-10.46-19.58-17.71-32.43-18.33-7.51-.36-15.51 1.21-22.24-2.15-5.83-2.91-9.43-8.95-14.75-12.72-17.68-12.55-36.48 10.9-56.62 5.57-6.77-1.79-14.18.75-19.47 5.35-7.87 6.83-9.07 19-17.9 24.67-9.78 6.29-20.22 3.16-28.52 14.96-7.53 10.7-3.68 18.79-5.15 30.08-1.46 11.26-11.92 17.78-13.39 29.02-1.67 12.79 5.61 17.57 9.75 27.75 4.46 10.97-1.62 17.22.26 28.65 3.49 21.21 17.83 14.97 29.92 25.24 6.11 5.19 4.28 19.45 11.37 26.9 5.28 5.55 12.79 9.19 20.44 9.74 6.38.46 13.96-4.59 19.6-3.11 7.6 1.99 14.42 13.55 22.98 16.53 15.68 5.47 20.25-6.38 33.08-9.53 9.83-2.41 20.75 7.75 33.45 3.93 13.38-4.02 14.04-13.41 21.8-22.2 6.51-7.38 13.99-5.99 21.99-11.04 8.6-5.45 10.89-15.6 14.07-24.82z",
    fill: "#f9d0ac"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270.81 151.87c-1.08 13.58-9.11 21.06-18.6 28.55-13.07 10.32-28.34 15.96-42.74 23.49-5.68 2.97-9.72 1.52-13.51-3.11-8.18-10.02-16.95-19.59-24.62-29.98-6.34-8.59-10.86-18.29-12.17-29.2-2.44-20.33 17.37-40.9 37.35-37.68 6.51 1.05 14.49 8.41 18.51 14.82 2.31 3.68 4.71 4.79 9.5 3.08 13.39-4.76 25.74-7.01 37.04.75 10.11 6.95 12.18 18.24 9.23 29.28z",
    fill: "#f3827c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M548.08 289.7c.47-2.71 1.03-5.37 1.84-7.86 3.61-11 13.82-20.61 10.14-33.01-1.91-6.45-6.91-11.42-10.88-16.86-9.37-12.82 1.13-22.83-4.46-35.43-4.87-10.98-15.76-15.74-26.35-19.68-11.31-4.21-13.42-17.32-21.18-25.3-8.92-9.16-22.14-14.37-34.93-12.93-7.47.84-15.12 3.66-22.3 1.42-6.22-1.95-10.73-7.34-16.58-10.21-19.45-9.57-34.28 16.56-55.01 14.5-6.97-.69-13.88 3-18.37 8.38-6.68 8-5.94 20.2-13.75 27.2-8.66 7.76-19.46 6.33-25.78 19.3-5.73 11.76-.65 19.14-.3 30.51.35 11.35-8.94 19.45-8.6 30.78.39 12.9 8.34 16.46 14.04 25.85 6.15 10.12 1.14 17.26 4.82 28.24 6.82 20.39 19.99 11.94 33.55 20.16 6.85 4.15 7.32 18.52 15.5 24.75 6.09 4.64 14.09 7.03 21.73 6.36 6.37-.56 13.05-6.75 18.86-6.19 7.82.75 16.39 11.08 25.31 12.67 16.35 2.91 18.97-9.52 31.15-14.67 9.33-3.94 21.71 4.35 33.65-1.44 12.57-6.1 11.73-15.47 17.99-25.39 5.25-8.32 12.86-8.14 19.95-14.4 7.63-6.75 8.27-17.13 9.94-26.75zM321.21 491.72c.9-2.6 1.87-5.14 3.07-7.47 5.31-10.28 16.92-18.15 15.26-30.98-.86-6.67-5-12.38-8.06-18.37-7.21-14.15 4.75-22.36 1.23-35.69-3.07-11.61-13.06-18.04-22.89-23.62-10.5-5.95-10.49-19.24-16.89-28.34-7.35-10.46-19.58-17.71-32.43-18.33-7.51-.36-15.51 1.21-22.24-2.15-5.83-2.91-9.43-8.95-14.75-12.72-17.68-12.55-36.48 10.9-56.62 5.57-6.77-1.79-14.18.75-19.47 5.35-7.87 6.83-9.07 19-17.9 24.67-9.78 6.29-20.22 3.16-28.52 14.96-7.53 10.7-3.68 18.79-5.15 30.08s-11.92 17.78-13.39 29.02c-1.67 12.79 5.61 17.57 9.75 27.75 4.46 10.97-1.62 17.22.26 28.65 3.49 21.21 17.83 14.97 29.92 25.24 6.11 5.19 4.28 19.45 11.37 26.9 5.28 5.55 12.79 9.19 20.44 9.74 6.38.46 13.96-4.59 19.6-3.11 7.6 1.99 14.42 13.55 22.98 16.53 15.68 5.47 20.25-6.38 33.08-9.53 9.83-2.41 20.75 7.75 33.45 3.93 13.38-4.02 14.04-13.41 21.8-22.2 6.51-7.38 13.99-5.99 21.99-11.04 8.6-5.45 10.89-15.6 14.07-24.82z",
    fill: "#f9d0ac"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230.88 79.38h.03c.01 0 .03-.01.04-.02l-.07.02z",
    fill: "#ac6a17"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158.9,
    cy: 398.7,
    r: 8.56,
    fill: "#ed8b99"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.95,
    cy: 478.65,
    r: 8.56,
    fill: "#ed8b99"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.28,
    cy: 416.63,
    r: 8.56,
    fill: "#ed8b99"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.55,
    cy: 493.5,
    r: 8.56,
    fill: "#ed8b99"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.59,
    cy: 459.2,
    r: 8.56,
    fill: "#ed8b99"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.84,
    cy: 376.68,
    r: 8.56,
    fill: "#ed8b99"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.92,
    cy: 440.2,
    r: 8.56,
    fill: "#ed8b99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M523.26 247.26c0 23.44-.88 50.07-17.21 65.43-16.33 15.36-43.57 18.22-68.49 18.22-27.57 0-47.78-7.7-64.34-26.03-13.37-14.8-35.28-34.36-35.28-55.31 0-22.81 10.73-37.46 26.29-52.71 16.42-16.1 46.35-37.09 71.95-37.09s38.32 17.83 54.65 33.19 32.43 30.86 32.43 54.29z",
    fill: "#eab2d1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 394.72,
    y: 213.3,
    width: 29.82,
    height: 6.74,
    rx: 3,
    ry: 3,
    transform: "rotate(-40.38 409.614 216.676)",
    fill: "#9dd0e4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 427.39,
    y: 229.38,
    width: 29.82,
    height: 6.74,
    rx: 3,
    ry: 3,
    fill: "#d5684e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 433.73,
    y: 192.38,
    width: 29.82,
    height: 6.74,
    rx: 3,
    ry: 3,
    transform: "rotate(39.07 448.64 195.748)",
    fill: "#f8dce2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 385.38,
    y: 254.79,
    width: 29.82,
    height: 6.74,
    rx: 3,
    ry: 3,
    transform: "rotate(-62.74 400.293 258.159)",
    fill: "#6bc39e"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 362.05,
    y: 234.57,
    width: 29.82,
    height: 6.74,
    rx: 3,
    ry: 3,
    transform: "rotate(60 376.962 237.937)",
    fill: "#d5684e"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 430.06,
    y: 265.77,
    width: 29.82,
    height: 6.74,
    rx: 3,
    ry: 3,
    transform: "rotate(-96.77 444.943 269.151)",
    fill: "#f8dce2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 466.76,
    y: 237.03,
    width: 29.82,
    height: 6.74,
    rx: 3,
    ry: 3,
    transform: "rotate(-56.39 481.637 240.403)",
    fill: "#9dd0e4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 465.67,
    y: 280.18,
    width: 29.82,
    height: 6.74,
    rx: 3,
    ry: 3,
    transform: "rotate(-119.13 480.56 283.558)",
    fill: "#6bc39e"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 413.28,
    y: 293.31,
    width: 29.82,
    height: 6.74,
    rx: 3,
    ry: 3,
    transform: "rotate(3.61 428.642 296.983)",
    fill: "#9dd0e4"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCookies, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cookies.9a645c7b.svg";
export { ForwardRef as ReactComponent };